<script setup>
import { AbcHeading, AbcIcon } from "@ordbogen-npm/abc-dsk";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import TgCheckbox from "@/abc-dsk/components/Form/TgCheckbox.vue";
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import { Color, Size } from "@/abc-dsk/options";
import { useVocabStore } from "@/stores";

defineProps({
  word: {
    type: String,
    required: true
  }
});
const emit = defineEmits(["cancel", "delete"]);
const { t } = useI18n();
const store = useVocabStore();

const { forceDeleteWord } = storeToRefs(store);

const dontAskAgain = ref(forceDeleteWord.value);

const onCancel = () => {
  dontAskAgain.value = false;
  emit("cancel");
};

const onRemove = () => {
  store.setForceDeleteWord(dontAskAgain.value);
  emit("delete");
};
</script>

<template>
  <TgModal alert :size="Size.Md" :color="Color.Yellow" @close="onCancel()">
    <AbcHeading tag="h1" size="md" color="black" class="d-flex align-items-center">
      <AbcIcon name="exclamation" class="mr-2" color="yellow" />
      <span>{{ t("vocab.vocabList.wordListItem.modalHeading") }}</span>
    </AbcHeading>
    <div class="row mt-3 mb-5">
      <div class="col-12 col-md-8">
        <p class="mb-0">
          {{ t("vocab.vocabList.wordListItem.modalExplanationText", { word }) }}
        </p>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 col-sm-4 col-md-6 d-flex align-items-center justify-content-center justify-content-sm-start mb-2 mb-sm-0"
      >
        <label class="d-inline-flex align-items-center">
          <TgCheckbox v-model="dontAskAgain" />
          <span class="ml-2">{{ t("vocab.vocabList.wordListItem.dontAskAgain") }}</span>
        </label>
      </div>
      <div
        class="col-12 col-sm-8 col-md-6 d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <TgButton color="grey" variant="text" class="mr-3" @click="onCancel()">
          {{ t("vocab.vocabList.wordListItem.cancelDelete") }}
        </TgButton>
        <TgButton size="md" color="yellow" @click="onRemove()">
          <span class="button-icon-wrapper">
            <span>{{ t("vocab.vocabList.wordListItem.delete") }}</span>
            <AbcIcon name="trash" color="white" />
          </span>
        </TgButton>
      </div>
    </div>
  </TgModal>
</template>

<style lang="less" scoped>
.button-icon-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
